var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import excitedDogGifSrc from '@images/onboarding/excited_dog.gif';
import firstNomGifSrc from '@images/onboarding/first_nom.gif';
import successDogGifSrc from '@images/onboarding/success_dog.gif';
import unboxingDryIceGifSrc from '@images/onboarding/unboxing_dry_ice.gif';
import unboxingFreezeGifSrc from '@images/onboarding/unboxing_freezer.gif';
import unboxingRecycleGifSrc from '@images/onboarding/unboxing_recycle.gif';
import _ from 'lodash';
var loaderImageMap = {
    excited_dog: excitedDogGifSrc,
    first_nom: firstNomGifSrc,
    success_dog: successDogGifSrc,
    unboxing_dry_ice: unboxingDryIceGifSrc,
    unboxing_freezer: unboxingFreezeGifSrc,
    unboxing_recycle: unboxingRecycleGifSrc,
};
var loaderImages = Object.keys(loaderImageMap);
var Loader = function (_a) {
    var _b = _a.image, image = _b === void 0 ? 'random' : _b;
    var selectedImageKey = image === 'random' ? _.sample(loaderImages) : image;
    return (_jsx("div", __assign({ className: "w-full flex-grow flex items-center justify-center" }, { children: _jsx("img", { src: loaderImageMap[selectedImageKey], alt: "Loading", width: "200", height: "200" }) })));
};
export default Loader;
